module.exports = __webpack_public_path__ + "static/media/openai.427468b3.svg";